import React from 'react'
import { Pagination } from '@instructure/ui-pagination'
import PaginationButton from '../paginationButton/PaginationButton.jsx'
import { IconArrowOpenEndSolid, IconArrowOpenStartSolid } from '@instructure/ui-icons'
import { useSelector } from 'react-redux'
import { Spinner } from '@instructure/ui-spinner'
import { Flex } from '@instructure/ui-flex'

const UsersPagination = () => {
  const paginationLinks = useSelector(state => state.courses.users?.result?.links)
  const working = useSelector(state => state.courses.users?.working)

  const { prev, next } = paginationLinks || {}

  return (
    <Flex alignItems="center" justifyItems="center">
      <Flex.Item>
        <Pagination as="nav" margin="small" variant="compact" disabled={working}>
          <PaginationButton link={prev} renderIcon={<IconArrowOpenStartSolid />} helperText="Previous Page" />
          <PaginationButton link={next} renderIcon={<IconArrowOpenEndSolid />} helperText="Next Page" />
        </Pagination>
      </Flex.Item>
      <Flex.Item margin="0 0 0 small" width="1.5rem">
        {working && <Spinner size="x-small" renderTitle='Loading users' />}
      </Flex.Item>
    </Flex>
  )
}

export default UsersPagination